import { SlotGameType1_21 } from '../SlotGameType1_21';

export class LuckyIce521 extends SlotGameType1_21
{
}
